export default __webpack_public_path__ + "static/media/Erio Hoti - Developer.a919a09e.jpg";